import { Injectable } from '@angular/core';
import { constants } from '../constants/constants';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../shared';
@Injectable({
  providedIn: 'root'
})
export class APIService {
    constructor() {}
    getURL(endpoint: string) {
      let updatedURL = SERVICE_END_POINT.higherEnvironment.CMS_EPI_URL + endpoint;
      return updatedURL;
    }
}